<!-- notifications.html -->

<div class="h-[calc(100vh-120px)] flex gap-4 overflow-hidden">

  <!-- ===================================== -->
  <!-- LEFT SIDEBAR -->
  <!-- ===================================== -->

  <div
    class="w-full lg:w-[32%] bg-white rounded-2xl border border-gray-200 overflow-hidden flex flex-col"
  >

    <!-- HEADER -->
    <div
      class="px-4 py-4 border-b border-gray-100 flex items-center justify-between"
    >

      <div>

        <h2
          class="text-lg font-bold text-[#0B0D5C]"
        >
          {{ 'NOTIFICATIONS.TITLE' | translate }}
        </h2>

        <p
          class="text-xs text-gray-500 mt-1"
        >
          {{ 'NOTIFICATIONS.COUNT' | translate: { count: notifications.length } }}
        </p>

      </div>

      <button
        (click)="markAllRead()"
        class="text-xs font-medium text-indigo-600 hover:text-indigo-700"
      >
        {{ 'NOTIFICATIONS.MARK_ALL_READ' | translate }}
      </button>

    </div>

    <!-- LOADING -->
    <div
      *ngIf="loading"
      class="flex-1 flex items-center justify-center text-gray-400 text-sm"
    >
      {{ 'NOTIFICATIONS.LOADING' | translate }}
    </div>

    <!-- EMPTY -->
    <div
      *ngIf="!loading && notifications.length === 0"
      class="flex-1 flex items-center justify-center text-gray-400 text-sm"
    >
      {{ 'NOTIFICATIONS.NO_NOTIFICATIONS_FOUND' | translate }}
    </div>

    <!-- LIST -->
    <div
      *ngIf="!loading && notifications.length > 0"
      class="overflow-y-auto flex-1"
    >

      @for (item of notifications; track item) {

        <div

          (click)="selectNotification(item)"

          class="px-4 py-4 border-b border-gray-100 cursor-pointer transition-all hover:bg-indigo-50"

          [class.bg-indigo-50]="
            selectedNotification?.notificationSeq === item.notificationSeq
          "
        >

          <div
            class="flex items-start gap-3"
          >

            <!-- ICON -->
            <div

              class="w-10 h-10 rounded-xl shrink-0 flex items-center justify-center"

              [class.bg-red-100]="
                item.notificationType === 'COMPLIANCE_ALERT'
              "

              [class.bg-indigo-100]="
                item.notificationType !== 'COMPLIANCE_ALERT'
              "
            >

              <svg
                class="w-5 h-5"

                [class.text-red-600]="
                  item.notificationType === 'COMPLIANCE_ALERT'
                "

                [class.text-indigo-600]="
                  item.notificationType !== 'COMPLIANCE_ALERT'
                "

                fill="none"
                stroke="currentColor"
                stroke-width="2"
                viewBox="0 0 24 24"
              >

                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12A9 9 0 1112 3a9 9 0 019 9z"
                />

              </svg>

            </div>

            <!-- CONTENT -->
            <div
              class="flex-1 min-w-0"
            >

              <div
                class="flex items-start justify-between gap-2"
              >

                <h3
                  class="text-sm font-semibold text-[#0B0D5C] truncate"
                >
                  {{ item.title }}
                </h3>

                <span
                  *ngIf="!item.read"
                  class="w-2 h-2 rounded-full bg-indigo-600 mt-1 shrink-0"
                >
                </span>

              </div>

              <p
                class="text-xs text-gray-500 mt-1 line-clamp-2 leading-5"
              >
                {{ item.message }}
              </p>

              <div
                class="flex items-center justify-between mt-2"
              >

                <span
                  class="text-[11px] text-gray-400"
                >
                  <span dir="ltr">{{ item.createdDate | date:'short' }}</span>
                </span>

                <button
                  (click)="viewDetails(item, $event)"
                  class="text-[11px] text-indigo-600 font-medium hover:underline"
                >
                  {{ 'COMMON.VIEW' | translate }}
                </button>

              </div>

            </div>

          </div>

        </div>

      }

    </div>

  </div>

  <!-- ===================================== -->
  <!-- RIGHT DETAILS -->
  <!-- ===================================== -->

  <div
    class="hidden lg:flex flex-1 bg-white rounded-2xl border border-gray-200 overflow-hidden"
  >

    <div
      *ngIf="selectedNotification"
      class="w-full flex flex-col"
    >

      <!-- HEADER -->
      <div
        class="px-6 py-5 border-b border-gray-100"
      >

        <div
          class="flex items-start justify-between gap-4"
        >

          <div>

            <div
              class="flex items-center gap-2 mb-2"
            >

              <span
                class="px-3 py-1 rounded-full text-xs font-medium bg-red-100 text-red-700"
              >
                {{ selectedNotification.notificationType | translate }}
              </span>

              <span
                class="text-xs text-gray-400"
              >
                <span dir="ltr">{{ selectedNotification.createdDate | date:'medium' }}</span>
              </span>

            </div>

            <h2
              class="text-2xl font-bold text-[#0B0D5C]"
            >
              {{ selectedNotification.title }}
            </h2>

          </div>

        </div>

      </div>

      <!-- BODY -->
      <div
        class="flex-1 overflow-y-auto p-6"
      >

        <!-- MESSAGE -->
        <div
          class="bg-gray-50 rounded-2xl p-5 border border-gray-100"
        >

          <h3
            class="text-sm font-semibold text-gray-700 mb-2"
          >
            {{ 'NOTIFICATIONS.MESSAGE' | translate }}
          </h3>

          <p
            class="text-sm text-gray-600 leading-7"
          >
            {{ selectedNotification.message }}
          </p>

        </div>

        <!-- DETAILS -->
        <div
          class="mt-6"
        >

          <h3
            class="text-base font-bold text-[#0B0D5C] mb-4"
          >
            {{ 'NOTIFICATIONS.CUSTOMER_DETAILS' | translate }}
          </h3>

          <div
            *ngIf="getPldFields(selectedNotification.pld).length === 0"
            class="text-sm text-gray-400"
          >
            {{ 'NOTIFICATIONS.NO_ADDITIONAL_DETAILS' | translate }}
          </div>

          <div
            *ngIf="getPldFields(selectedNotification.pld).length > 0"
            class="grid grid-cols-1 md:grid-cols-2 gap-4"
          >

            @for (field of getPldFields(selectedNotification.pld); track field.key) {

              <div
                class="bg-white border border-gray-200 rounded-xl p-4 min-w-0"
                [class.md:col-span-2]="field.label === 'Address' || field.label === 'Document Name'"
              >
                <p class="text-xs text-gray-400 mb-1">
                  {{ getFieldLabelKey(field.label) | translate }}
                </p>

                <p class="text-sm font-semibold text-gray-800 break-words whitespace-pre-wrap">
                  {{ field.value }}
                </p>
              </div>

            }

          </div>

        </div>

      </div>

    </div>

    <!-- EMPTY RIGHT -->
    <div
      *ngIf="!selectedNotification"
      class="w-full flex items-center justify-center text-gray-400"
    >

      {{ 'NOTIFICATIONS.SELECT_TO_VIEW' | translate }}

    </div>

  </div>

</div>

<!-- ===================================== -->
<!-- MOBILE DETAILS POPUP -->
<!-- ===================================== -->

@if (showPopup && selectedNotification) {

  <div
    class="fixed inset-0 z-[9999] bg-black/50 flex items-end sm:items-center justify-center"
  >

    <div
      class="bg-white w-full sm:max-w-2xl rounded-t-3xl sm:rounded-3xl max-h-[90vh] overflow-hidden"
    >

      <!-- HEADER -->
      <div
        class="px-5 py-4 border-b border-gray-100 flex items-center justify-between"
      >

        <h2
          class="text-lg font-bold text-[#0B0D5C]"
        >
          {{ 'NOTIFICATIONS.DETAILS_TITLE' | translate }}
        </h2>

        <button
          (click)="showPopup = false"
          class="w-9 h-9 rounded-full border flex items-center justify-center"
        >
          ✕
        </button>

      </div>

      <!-- BODY -->
      <div
        class="p-5 overflow-y-auto"
      >

        <h3
          class="text-xl font-bold text-[#0B0D5C]"
        >
          {{ selectedNotification.title }}
        </h3>

        <p
          class="text-sm text-gray-500 mt-3 leading-7"
        >
          {{ selectedNotification.message }}
        </p>

        <div
          class="mt-6 space-y-4"
        >

          <div
            *ngIf="getPldFields(selectedNotification.pld).length === 0"
            class="text-sm text-gray-400"
          >
            {{ 'NOTIFICATIONS.NO_ADDITIONAL_DETAILS' | translate }}
          </div>

          @for (field of getPldFields(selectedNotification.pld); track field.key) {

            <div class="border rounded-xl p-4 min-w-0">
              <p class="text-xs text-gray-400">{{ getFieldLabelKey(field.label) | translate }}</p>
              <p class="font-semibold mt-1 break-words whitespace-pre-wrap">
                {{ field.value }}
              </p>
            </div>

          }

        </div>

      </div>

    </div>

  </div>

}